import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { AbstractControl,FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BooleanEnum } from "src/app/constants/boolean-enum";
import { EnrollModuleClass } from "src/app/constants/enroll-module-class";
import { BenefitWizardType } from "src/app/constants/wizard-panels";
import { AdditionalModuleBase, AdditionalModulePayload, EnrollModuleBeneficiaryPayload, EnrollModuleQuestion, EnrollModuleQuestionPayload } from "src/app/models/additional-info";
import { Beneficiary, BeneficiaryPayload } from "src/app/models/beneficiary";
import { ListItem } from "src/app/models/listItem";
import { BeneficiariesService } from "src/app/services/beneficiaries.service";
import { EnrollmentManagerService } from "src/app/services/enrollment-manager.service";
import { HelperService } from "src/app/services/helper.service";
import { LookupService } from "src/app/services/lookup.service";

// Double Check Beneficiary Logic
// Make sure 

@Component({
    selector: 'mwp-benefit-enrollment-wizard-carrier-module',
    templateUrl: './carrier-module.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CarrierModuleComponent implements OnInit {
    @Input() public additionalModuleBase: AdditionalModuleBase;

    @Output() public emitCancel: EventEmitter<any> = new EventEmitter();
    @Output() public emitComplete: EventEmitter<AdditionalModulePayload> = new EventEmitter();

    public displayEnrollModuleQuestions: boolean;
    public formArrayName: string = 'formArrayNameSoOriginal';
    public booleanEnum = BooleanEnum;
    public isNotConfigured: boolean;
    public panelName: string;
    public carrierForm: FormGroup;

    public displayBenficaryPrimaryGrid: boolean;
    public relationshipsList: ListItem[];
    public beneficiaryListArrayName: string = 'beneficiaryList';
    public beneficiaryHeaderName: string = 'beneficiaryHeaderName';

    constructor(
        private enrollmentManagerService: EnrollmentManagerService,
        private formBuilder: FormBuilder,
        private lookupService: LookupService,
        private helperService: HelperService,
        private beneficiariesService: BeneficiariesService,
    ){
    }

    ngOnInit(){
        switch(this.enrollmentManagerService.manager.BenefitWizardType) {
            case BenefitWizardType.Add:
            case BenefitWizardType.BuyUp:
                switch (this.additionalModuleBase.enrollModule) {
                    case EnrollModuleClass.AmericanFidelityLife:
                        this.buildQuestionFom();
                        break;

                    case EnrollModuleClass.TransamericaAccident17:
                        this.lookupService.getTransamericaAccident17Relationships().subscribe((response: ListItem[]) => {
                            this.relationshipsList = response;
                        });
                        this.buildBeneficaryForm();
                        break;

                    case EnrollModuleClass.TransamericaAccident18:
                        this.lookupService.getTransamericaAccident18Relationships().subscribe((response: ListItem[]) => {
                            this.relationshipsList = response;
                        });
                        this.buildBeneficaryForm();
                        break;

                    default:
                        this.displayErrorScreen();
                        break;
                }
                break;

            default:
                this.displayErrorScreen();
                break;
        }
    }

    private buildQuestionFom(): void {
        if (this.additionalModuleBase.enrollModuleQuestions && this.additionalModuleBase.enrollModuleQuestions.length > 0) {
            let l_FormArray: FormArray = new FormArray([]);

            this.additionalModuleBase.enrollModuleQuestions.forEach((question: EnrollModuleQuestion) => {
                l_FormArray.push(
                    this.formBuilder.group({
                        id: [question.id],
                        name: [question.name],
                        questionResponse: [question.questionResponse, Validators.required],
                    })
                );
            });

            this.carrierForm = this.formBuilder.group({
                [this.formArrayName]: l_FormArray,
            });

            this.displayEnrollModuleQuestions = true;
        } else {
            this.displayErrorScreen();
        }
    }

    private buildBeneficaryForm(): void {
        if (this.additionalModuleBase.enrollModuleQuestions && this.additionalModuleBase.enrollModuleQuestions.length > 0)
            this.buildQuestionFom();

        let l_FormArray: FormArray = new FormArray([]);
        l_FormArray.push(
            this.formBuilder.group({
                [this.beneficiaryHeaderName]: ['Required'],
                firstName: [null, Validators.required],
                lastName: [null, Validators.required],
                relationship: [null, Validators.required],
                tempPercentage: [null, Validators.required],
                isPrimary: [true],
                isSelected: [true],
            })
        );
        l_FormArray.push(
            this.formBuilder.group({
                [this.beneficiaryHeaderName]: ['Optional'],
                firstName: [null],
                lastName: [null],
                relationship: [null],
                tempPercentage: [null],
                isPrimary: [false],
                isSelected: [false],
            })
        );

        if (this.carrierForm)
            this.carrierForm.addControl(this.beneficiaryListArrayName, l_FormArray);
        else
            this.carrierForm = this.formBuilder.group({
                [this.beneficiaryListArrayName]: l_FormArray,
            });

        this.displayBenficaryPrimaryGrid = true
    }

    public getFormGroup(indexId: number): FormGroup {
        const l_Array = this.carrierForm.get(this.formArrayName) as FormArray;
        return l_Array.controls[indexId] as FormGroup;
    }

    get gridBeneficiaryArrayControls(): AbstractControl[] {
        const l_Array = (<FormArray>(this.carrierForm.get(this.beneficiaryListArrayName)));
        return l_Array.controls;
    }

    private displayErrorScreen(): void {
        this.panelName = `Carrier Module - ${this.additionalModuleBase.enrollModule}`;
        this.isNotConfigured = true;
    }

    public getBeneficiaryHeaderName(group: any): string {
        return group.get(this.beneficiaryHeaderName).value;
    }

    

    public onChangeValidation(index: number): void {
        const l_Array = (<FormArray>(this.carrierForm.get(this.beneficiaryListArrayName)));
        const l_FormGroup = l_Array.controls[index] as FormGroup;

        if (l_FormGroup.get(this.beneficiaryHeaderName).value == 'Optional') {
            let l_FirstName = l_FormGroup.get('firstName');
            let l_LastName = l_FormGroup.get('lastName');
            let l_Relationship = l_FormGroup.get('relationship');
            let l_Percentage = l_FormGroup.get('tempPercentage');
            let l_IsPrimary = l_FormGroup.get('isPrimary');
            let l_IsSelected = l_FormGroup.get('isSelected');

            if (l_FirstName.value || l_LastName.value || l_Relationship.value || l_Percentage.value) {
                l_FirstName.setValidators(Validators.required);
                l_LastName.setValidators(Validators.required);
                l_Relationship.setValidators(Validators.required);
                l_Percentage.setValidators(Validators.required);
                l_IsPrimary.setValue(true);
                l_IsSelected.setValue(true);
            } else {
                l_FirstName.clearValidators();
                l_LastName.clearValidators();
                l_Relationship.clearValidators();
                l_Percentage.clearValidators();
                l_IsPrimary.setValue(false);
                l_IsSelected.setValue(false);
            }

            l_FirstName.updateValueAndValidity();
            l_LastName.updateValueAndValidity();
            l_Relationship.updateValueAndValidity();
            l_Percentage.updateValueAndValidity();
        }
    }

    public cancel(): void {
        this.emitCancel.emit();
    }

    public submitComplete() {
        const l_AdditionalModulePayload: AdditionalModulePayload = new AdditionalModulePayload();
        l_AdditionalModulePayload.enrollModule = this.additionalModuleBase.enrollModule;

        if (this.displayBenficaryPrimaryGrid) {
            const l_BeneficiaryPayload: BeneficiaryPayload = new BeneficiaryPayload();
            const l_Array = (<FormArray>(this.carrierForm.get(this.beneficiaryListArrayName)));
            l_Array.controls.forEach((fg) => {
                const l_FG = fg as FormGroup;
                if (l_FG.get('isSelected').value)
                    l_BeneficiaryPayload.beneficiaryList.push(this.helperService.convertFormGroupIntoObject(l_FG, new Beneficiary()));

            });

            const l_Payload = this.beneficiariesService.beneficariesPaylodValidation(l_BeneficiaryPayload);
            if (l_Payload) {
                l_Payload.beneficiaryList.forEach((x: Beneficiary) => {
                    const l_EnrollModuleBeneficiaryPayload = new EnrollModuleBeneficiaryPayload();
                    l_EnrollModuleBeneficiaryPayload.isPrimary = x.isPrimary;
                    l_EnrollModuleBeneficiaryPayload.firstName = x.firstName;
                    l_EnrollModuleBeneficiaryPayload.lastName = x.lastName;
                    l_EnrollModuleBeneficiaryPayload.percentage = x.percentage;
                    l_EnrollModuleBeneficiaryPayload.relationship = x.relationship;
                    l_AdditionalModulePayload.enrollModuleBeneficiaries.push(l_EnrollModuleBeneficiaryPayload);
                });
            } else {
                return;
            }
        }

        if (this.displayEnrollModuleQuestions) {
            const l_Array = (<FormArray>(this.carrierForm.get(this.formArrayName)));
            l_Array.controls.forEach((fg) => { 
                const l_FG = fg as FormGroup;
                l_AdditionalModulePayload.enrollModuleQuestions.push(this.helperService.convertFormGroupIntoObject(l_FG, new EnrollModuleQuestionPayload()));
            });
        }

        this.emitComplete.emit(l_AdditionalModulePayload);
    }
}